import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"

import { cn } from "@/lib/utils"

export function Root({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Root>) {
  return (
    <ToggleGroupPrimitive.Root {...props} className={cn("flex gap-1", className)}>
      {children}
    </ToggleGroupPrimitive.Root>
  )
}

type ToggleItemVariant = {
  iconOnly?: boolean
}

export function Item({
  className,
  children,
  iconOnly = false,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Item> & ToggleItemVariant) {
  return (
    <ToggleGroupPrimitive.Item
      {...props}
      className={cn(
        "rounded-md p-2",
        "-mr-6 border border-border bg-sand-200 px-4 text-body2",
        "hover:bg-grey-100 aria-checked:hover:cursor-default",
        "data-[disabled]:cursor-default data-[disabled]:bg-muted",
        "aria-[checked=false]:text-muted-foreground",
        "disabled:aria-checked:text-muted-foreground disabled:aria-[checked=false]:text-muted-foreground/60",
        "aria-checked:z-10 aria-checked:bg-white",
        "aria-checked:first-of-type:-mr-6 aria-checked:first-of-type:pr-4",
        "aria-checked:last-of-type:pl-4",
        "first-of-type:pr-8",
        "last-of-type:mr-0 last-of-type:pr-4 last-of-type:pl-8",
        className,
      )}
    >
      <span className={iconOnly ? "w-fit" : "inline-block min-w-25"}>{children}</span>
    </ToggleGroupPrimitive.Item>
  )
}
